/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');

Odigeo.defineWidget('direct_flights_search_manager', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            directFlightsOnly: false,
        },
    })),

    viewClass: Odigeo.View.extend({
        events: {
            'change input[type=checkbox]': 'onChange',
        },

        selectors: {
            input: '.direct_flights_selector_input',
        },

        init: function() {
            this.listenTo(this.model, 'sync:fetch', this.render);
            this.render();
        },

        render: function() {
            this.$cachedSelectors.input.prop('checked', this.model.get('directFlightsOnly'));
            return this;
        },

        onChange: function(event) {
            this.model.save({'directFlightsOnly': event.currentTarget.checked});
        },
    }),
}));
